import axios from "axios";
import React, { useEffect, useState } from "react";
import { CiLocationOn, CiMail, CiStar } from "react-icons/ci";
import { HiOutlineClipboard } from "react-icons/hi";
import { IoBookOutline } from "react-icons/io5";
import { PiPhoneCallLight } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";

const TeacherAssign = () => {
  const [teacherProfile, setTeacherProfile] = useState();
  const [requestId, setRequestId] = useState("");
  const [teachersId, setTeachersId] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { hwId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    setRequestId(hwId);
  }, [API_BASE_URL]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/admin/teachers`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response.data?.data);
        setTeacherProfile(response.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //   console.log("request id", requestId);
  //   console.log("teachers id ", teachersId);

  const handleSubmit = async () => {
    if (teachersId.length === 0) {
      alert("Please select one teacher.");
      return;
    }
    try {
      await axios
        .put(
          `${API_BASE_URL}/admin/homework/approve/${requestId}`,
          {
            homeWorkApproval: "approved",
            teacherId: teachersId,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          alert("Teacher has been assign for Home Work");
          navigate("/home-work-assistance/student-hw-list");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div id="teacher-profile-container">
        <div className="d-flex w-100 justify-content-between align-items-center ">
          <h1>
            <b>Teacher's Profile</b>
          </h1>
          <button className="new-chapter-submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
        <div className="teacher-profile-inner-div">
          {teacherProfile &&
            teacherProfile.map((data, idx) => (
              <div
                className="teacher-profile-card-container d-flex flex-column align-items-start p-2"
                key={idx}
              >
                <div className="ps-4 fs-5">
                  <label htmlFor="selectTeacher">Select Teacher : </label>
                  <input
                    type="radio"
                    id="selectTeacher"
                    name="teacherId"
                    value={data._id}
                    onChange={(e) => setTeachersId(e.target.value)}
                    className="ms-2 fs-5 form-check-input mb-2"
                  />
                </div>
                <div className="w-100 d-flex">
                  <div className="teacher-profile-share-teacher-image-box">
                    <img
                      src={`${API_BASE_URL}/uploads/${data.basicInfo.profilePicture}`}
                      alt="teacher-img"
                    />
                  </div>

                  <div className="teacher-profile-teacher-details-box">
                    <p className="student-name-b">
                      <b>{data.basicInfo.fullName}</b>
                      <br />
                      <span style={{ color: "#404040", fontSize: "18px" }}>
                        <CiStar />
                        <CiStar />
                        <CiStar />
                        <CiStar />
                        <CiStar />
                      </span>
                    </p>
                    <p className="student-phone-and-email">
                      <span className="student-contact">
                        <PiPhoneCallLight className="icon-margin" />
                        {data.basicInfo?.contactNumber}
                      </span>
                      <span className="student-email">
                        <CiMail className="icon-margin" />
                        {data.basicInfo?.email}
                      </span>
                    </p>
                    <p className="student-address">
                      <CiLocationOn className="icon-margin" />
                      {data.basicInfo?.address}
                    </p>
                    <p className="teacher-accept-class-checks-boxes">
                      {/* <div>
                      <HiOutlineClipboard />
                    </div> */}
                      <div className="d-flex flex-column gap-2">
                        {data.professionalInfo?.teachingDetails.map(
                          (item, idx) => (
                            <div key={idx} className="w-100">
                              <HiOutlineClipboard className="icon" />
                              {item.className} -{" "}
                              <span>
                                <IoBookOutline className="icon" />
                                {item?.subjects.map((sub, idx) => (
                                  <span key={idx}>{sub.subjectName} , </span>
                                ))}
                              </span>{" "}
                            </div>
                          )
                        )}
                      </div>
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default TeacherAssign;
